import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    tipoEvento: '',
    fecha: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4p7sdar20r5k3vfkg40', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          tipoEvento: '',
          fecha: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="contacto" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat',sans-serif] text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Contáctanos
          </h2>
          <p className="font-['Poppins',sans-serif] text-base text-gray-600 max-w-2xl mx-auto">
            Estamos listos para hacer realidad tu evento. Cuéntanos tus ideas y te ayudaremos a crear una experiencia inolvidable
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <form id="contact-form" onSubmit={handleSubmit} className="space-y-6" data-readdy-form>
              <div>
                <label htmlFor="nombre" className="block font-['Poppins',sans-serif] text-sm font-medium text-gray-700 mb-2">
                  Nombre Completo *
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all"
                  placeholder="Tu nombre completo"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="email" className="block font-['Poppins',sans-serif] text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="telefono" className="block font-['Poppins',sans-serif] text-sm font-medium text-gray-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all"
                    placeholder="(123) 456-7890"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="tipoEvento" className="block font-['Poppins',sans-serif] text-sm font-medium text-gray-700 mb-2">
                    Tipo de Evento *
                  </label>
                  <select
                    id="tipoEvento"
                    name="tipoEvento"
                    value={formData.tipoEvento}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all cursor-pointer"
                  >
                    <option value="">Selecciona una opción</option>
                    <option value="boda">Boda</option>
                    <option value="xv-anos">XV Años</option>
                    <option value="corporativo">Evento Corporativo</option>
                    <option value="concierto">Concierto</option>
                    <option value="fiesta-privada">Fiesta Privada</option>
                    <option value="grabacion">Grabación en Estudio</option>
                    <option value="renta-sonido">Renta de Sonido</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="fecha" className="block font-['Poppins',sans-serif] text-sm font-medium text-gray-700 mb-2">
                    Fecha del Evento
                  </label>
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleChange}
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all cursor-pointer"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="mensaje" className="block font-['Poppins',sans-serif] text-sm font-medium text-gray-700 mb-2">
                  Mensaje *
                </label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all resize-none"
                  placeholder="Cuéntanos sobre tu evento, número de invitados, ubicación y cualquier detalle importante..."
                />
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-teal-600 to-teal-500 text-white px-8 py-4 rounded-lg text-base font-semibold hover:from-teal-700 hover:to-teal-600 transition-all shadow-lg whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
                  ¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                  Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.
                </div>
              )}
            </form>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="font-['Montserrat',sans-serif] text-2xl font-bold text-gray-900 mb-6">
                Información de Contacto
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-['Montserrat',sans-serif] text-base font-bold text-gray-900 mb-1">
                      Ubicación
                    </h4>
                    <p className="font-['Poppins',sans-serif] text-sm text-gray-600">
                      Flores Magón, Cuernavaca, Morelos
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-['Montserrat',sans-serif] text-base font-bold text-gray-900 mb-1">
                      Teléfono
                    </h4>
                    <p className="font-['Poppins',sans-serif] text-sm text-gray-600">
                      Manager: 777-114-3440<br />
                      Oficina: 551-173-3326
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-['Montserrat',sans-serif] text-base font-bold text-gray-900 mb-1">
                      Email
                    </h4>
                    <p className="font-['Poppins',sans-serif] text-sm text-gray-600">
                      vicmagico@gmail.com
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                    <i className="ri-time-line text-2xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h4 className="font-['Montserrat',sans-serif] text-base font-bold text-gray-900 mb-1">
                      Horario
                    </h4>
                    <p className="font-['Poppins',sans-serif] text-sm text-gray-600">
                      Lunes a Sábado: 9:00 AM - 8:00 PM<br />
                      Domingo: 10:00 AM - 6:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-600 to-teal-500 rounded-2xl p-8 shadow-lg text-white">
              <h3 className="font-['Montserrat',sans-serif] text-2xl font-bold mb-4">
                ¿Listo para tu evento?
              </h3>
              <p className="font-['Poppins',sans-serif] text-sm mb-6 opacity-95">
                Contáctanos hoy y recibe una cotización personalizada sin compromiso. Nuestro equipo está listo para asesorarte.
              </p>
              <div className="flex gap-4">
                <a 
                  href="https://wa.me/5217771143440" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl hover:bg-white/30 transition-all cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-2xl w-6 h-6 flex items-center justify-center"></i>
                </a>
                <a 
                  href="https://www.facebook.com/Americanmusicv/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl hover:bg-white/30 transition-all cursor-pointer"
                >
                  <i className="ri-facebook-fill text-2xl w-6 h-6 flex items-center justify-center"></i>
                </a>
                <a 
                  href="https://instagram.com/esferarecords" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl hover:bg-white/30 transition-all cursor-pointer"
                >
                  <i className="ri-instagram-line text-2xl w-6 h-6 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
